
import { Client, FxMargins } from 'ah-api-gateways';
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import ClientMarginEditModal from '../ClientMarginEditModal.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';

@Component({
  components: {
    ClientMarginEditModal,
  },
})
export default class ClientMarkupInfo extends Mixins(WithRequestManager) {
  @Prop({ default: null }) client!: Client | null;

  private settings: FxMargins | null = null;

  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'getClientSettings') {
      this.onClientChange();
    }
  }

  @Watch('client', { immediate: true })
  onClientChange() {
    if (this.client) {
      this.requestManager
        .sameOrCancelAndNew('getClientSettings', this.$services.spreads.getClientSpreads(this.client.id))
        .subscribe((settings) => (this.settings = settings));
    }
  }

  onClientUpdated(settings: FxMargins) {
    this.settings = settings;
  }
}
